var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Down 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Arrow---Down-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Down-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M3.72407 6.64107C3.94596 6.41918 4.29318 6.39901 4.53786 6.58055L4.60796 6.64107L9.99935 12.0322L15.3907 6.64107C15.6126 6.41918 15.9598 6.39901 16.2045 6.58055L16.2746 6.64107C16.4965 6.86295 16.5167 7.21017 16.3351 7.45485L16.2746 7.52495L10.4413 13.3583C10.2194 13.5802 9.87218 13.6003 9.62751 13.4188L9.55741 13.3583L3.72407 7.52495C3.48 7.28087 3.48 6.88514 3.72407 6.64107Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.124ff94d62531f54d0be1232f5326835.svg";
export { ForwardRef as ReactComponent };